import React from 'react';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';

class FormConfValidacaoFormsSubLista extends React.Component {         
    render() {
        
        return (                
            <tbody>
                <tr>
                    <th>Descricao</th>
                    <th>Obrigatório</th>
                    <th>Ocultar</th>
                </tr>
                {this.props.cadastros.length?this.props.cadastros.map((itens, indice) => {
                    if(!itens.baseform){
                        return null;
                    }

                    return (
                        <tr key={indice}>
                            <td className="text-break">
                                {itens.baseform?itens.baseform.descricao:null}
                            </td>
                            <td className="text-center">
                                <ToggleButtonGroup type="checkbox" value={itens.campoobrigatorio} className="mb-2">
                                    <ToggleButton 
                                    onChange={(e) => this.props.handleEditar({campo: 'campoobrigatorio', value: e.currentTarget.value}, itens)} 
                                    type="radio" 
                                    variant={itens.campoobrigatorio==='S'?"success":"secondary"}
                                    value="S"
                                    checked={itens.campoobrigatorio==='S'?true:false}>Sim</ToggleButton>

                                    <ToggleButton 
                                    onChange={(e) => this.props.handleEditar({campo: 'campoobrigatorio', value: e.currentTarget.value}, itens)} 
                                    type="radio"
                                    variant={itens.campoobrigatorio==='N'?"success":"secondary"}
                                    value="N" 
                                    checked={itens.campoobrigatorio==='N'?true:false}>Não</ToggleButton>                                
                                </ToggleButtonGroup>
                            </td>
                            <td className="text-center">
                                <ToggleButtonGroup type="checkbox" value={itens.ocultacampo} className="mb-2">                                
                                    <ToggleButton 
                                    onChange={(e) => this.props.handleEditar({campo: 'ocultacampo', value: e.currentTarget.value}, itens)} 
                                    type="radio"
                                    variant={itens.ocultacampo==='S'?"success":"secondary"}
                                    value="S" 
                                    checked={itens.ocultacampo==='S'?true:false}>Sim</ToggleButton>
                                    <ToggleButton 
                                    onChange={(e) => this.props.handleEditar({campo: 'ocultacampo', value: e.currentTarget.value}, itens)} 
                                    type="radio" 
                                    variant={itens.ocultacampo==='N'?"success":"secondary"}                                    
                                    value="N" 
                                    checked={itens.ocultacampo==='N'?true:false}>Não</ToggleButton>
                                </ToggleButtonGroup>
                            </td>                        
                        </tr>  
                    )
                })
                :
                null
            }
        </tbody>
        );
    }
}

export default FormConfValidacaoFormsSubLista;